import { render, staticRenderFns } from "./GaWrapper.vue?vue&type=template&id=616b15bb&lang=pug&"
import script from "./GaWrapper.vue?vue&type=script&lang=js&"
export * from "./GaWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports